<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <material-card
          color="secondary"
          title="Faturas Individualizadas"
          text=""
        >
          <v-flex xs12 md12 class="text-lg-right">
            <div
              class="text-xs-rigth text-md-rigth text-lg-rigth"
              v-if="items.length > 0"
            >
              <v-btn
                color="primary"
                outline
                slot="start"
                @click="_export(items)"
              >
                <v-icon left>mdi-file-excel</v-icon>Exportar
              </v-btn>
            </div>
          </v-flex>
          <v-data-table
            dense
            :headers="headers"
            :items="items"
            hide-actions
            :loading="true"
            no-data-text="Não há faturas para essa competencia"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading text-xs-right font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.user.name | formatName }}</td>
              <td class="text-xs-right">
                {{ item.amount_kW || 0 | formatCurrency }}
              </td>
              <td class="text-xs-right" v-if="total">
                {{ (item.amount_kW / total) * 100 || 0 | formatPercent }}%
              </td>
              <td class="text-xs-right" v-else>-</td>
              <td class="text-xs-right">
                R$ {{ item.amount || 0 | formatCurrency }}
              </td>
              <td class="text-xs-right">
                R$ {{ item.total || 0 | formatCurrency }}
              </td>

              <!-- Para faturas antes de 07/2019 - Antes da Mudança para Pagarme -->
              <td
                class="text-xs-right"
                v-if="item.transaction && item.competence < '2019-07'"
              >
                R$
                {{
                  item.transaction
                    ? item.transaction.cost
                    : 0 || 0 | formatCurrency
                }}
              </td>
              <td
                class="text-xs-right"
                v-if="item.transaction && item.competence < '2019-07'"
              >
                R$
                {{
                  item.transaction
                    ? item.total - item.transaction.cost
                    : 0 || 0 | formatCurrency
                }}
              </td>
              <td class="text-xs-center" v-if="!item.transaction">-</td>

              <!-- Para faturas de 07/2019 em diante - Após Mudança para Pagarme -->
              <td
                class="text-xs-right"
                v-if="item.transactionPagarme && item.competence >= '2019-07'"
              >
                R$
                {{
                  (sumFee(item.transactionPagarme.payables) +
                    (item.transactionPagarme.payment_method === "credit_card"
                      ? item.transactionPagarme.cost / 100
                      : 0))
                    | formatCurrency
                }}
              </td>
              <td
                class="text-xs-right"
                v-if="item.transactionPagarme && item.competence >= '2019-07'"
              >
                R$
                {{
                  item.transactionPagarme
                    ? item.total -
                      (sumFee(item.transactionPagarme.payables) +
                        (item.transactionPagarme.payment_method ===
                        "credit_card"
                          ? item.transactionPagarme.cost / 100
                          : 0))
                    : 0 || 0 | formatCurrency
                }}
              </td>
              <td class="text-xs-center" v-if="!item.transactionPagarme">-</td>

              <td class="text-xs-right">
                R$ {{ item.discount || 0 | formatCurrency }}
              </td>
              <td class="text-xs-right" v-if="item.transaction">
                <v-icon @click.prevent="gotoTransactionHistory(item.id)">{{
                  item.transaction
                    ? item.transaction.payment_method
                    : "" || "" | formatPaymentType
                }}</v-icon>
              </td>
              <td class="text-xs-right" v-else>-</td>
              <td class="text-xs-right">
                <a :href="url(item)" target="_blank"
                  ><v-icon>mdi-whatsapp</v-icon></a
                >
              </td>
              <td class="text-xs-right">
                <v-icon
                  v-if="
                    item.status !== 'paga' &&
                    item.status !== 'succeeded' &&
                    item.status !== 'paid'
                  "
                  @click.prevent="gotoTransactionHistory(item.id)"
                  >{{ item.status | formatStatus }}</v-icon
                >
                <v-icon
                  color="primary"
                  v-else
                  @click.prevent="gotoTransactionHistory(item.id)"
                  >{{ item.status | formatStatus }}</v-icon
                >
              </td>
            </template>
          </v-data-table>
          <template v-slot:loading>
            <v-progress-linear
              v-if="loading"
              height="2"
              color="cyan"
              indeterminate
            ></v-progress-linear>
          </template>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { EventBus } from "../../utils/event-bus";
import XLSX from "xlsx";
import moment from "moment";
import { eventBus } from "../../main";

export default {
  //props: ['items', 'total'],
  data: () => ({
    loading: false,
    dialog: false,
    items: [],
    total: 0,
    cols: [],
    data: [
      [
        "Indice",
        "Competencia",
        "Nome",
        // 'UC',
        "Créditos kWh",
        "Consumo kWh",
        "Custo de Disponibilidade kWh",
        "% de Aluguel",
        "Créditos",
        "Mensalidade",
        "Taxa",
        "Receita Liquida",
        "Economia",
        "Saldo",
        "Método de Pagamento",
        "Status",
        "ID do Usuário",
      ],
    ],
    headers: [
      {
        sortable: true,
        text: "Nome",
        value: "name",
      },
      {
        sortable: true,
        text: "Créditos kW",
        value: "item.amount_kW",
      },
      {
        sortable: true,
        text: "%",
        value: "percent",
      },
      {
        sortable: false,
        text: "Créditos",
        value: "amount",
      },
      {
        sortable: false,
        text: "Mensalidade",
        value: "total",
      },
      {
        sortable: false,
        text: "Taxa",
        value: "transaction",
      },
      {
        sortable: false,
        text: "Receita",
        value: "fat",
      },
      {
        sortable: false,
        text: "Economia",
        value: "discount",
      },
      {
        sortable: false,
        text: "Mét. Pag.",
        value: "transaction.payment_method",
      },
      {
        sortable: false,
        text: "Whatsapp",
        value: "whatsapp",
      },
      {
        sortable: false,
        text: "Status",
        value: "status",
      },
    ],
  }),
  mounted() {
    EventBus.$on("LoadInvoices", (invoices) => {
      // console.log('LoadInvoices: ', invoices)
      this.items = invoices;
      // console.log('invoices: ', invoices)
    });
    EventBus.$on("InvoiceTotal", (total) => {
      // this.total = total.power_plant_amount
      this.total = total.total_amount_kw || 0;
      // this.total = total.power_plant_amount + (total.last_balance - total.current_balance - total.total_consumo_kW)
      // console.log('total: ', this.total)
    });
  },
  methods: {
    formatWhatsappPhone(phone) {
      let newphone = phone.replace(/\D/g, "");
      if (newphone.substring(0, 2) !== "55") {
        newphone = "55" + newphone;
      }
      return newphone;
    },
    url(item) {
      // console.log('item: ', item)
      const creditos = item.tarifa;
      const desconto_indicacao = item.referral_balance
        ? item.referral_balance
        : 0;
      const valor_desconto = item.tarifa - item.total;
      const custo_disp = item.custo_disp ? item.custo_disp : 0;
      let pagamento = 0;
      let economia = 0;
      if (item.competence > "2020-01") {
        pagamento = item.total;
        economia = item.discount + desconto_indicacao;
        // console.log('economia: ', economia)
      } else {
        if (item.power_plant_id === "ufvpedralva1") {
          pagamento = creditos - valor_desconto - desconto_indicacao;
        } else {
          pagamento =
            creditos - custo_disp - valor_desconto - desconto_indicacao;
        }
        economia = item.discount + desconto_indicacao;
        // console.log('economia2: ', economia)
      }
      const valor = this.formatCurrencyEmail(pagamento);
      const competencia =
        item.competence.split("-")[1] + "/" + item.competence.split("-")[0];
      economia = this.formatCurrencyEmail(economia);
      let message = "";
      let url =
        "https://web.whatsapp.com/send?phone=" +
        this.formatWhatsappPhone(item.user.phone) +
        "&text=";
      let nome = item.user.name ? item.user.name.split(" ")[0] : "";

      if (item.transaction) {
        if (item.transaction.payment_method === "boleto") {
          let barcode = item.transaction.boleto_barcode
            ? item.transaction.boleto_barcode
            : item.transactionPagarme.boleto_barcode;
          let venc =
            moment(
              item.transaction.boleto_expiration_date
                ? item.transaction.boleto_expiration_date
                : item.transactionPagarme.boleto_expiration_date,
            ).format("DD/MM/YYYY") || "";
          let boleto_url = item.transaction.boleto_url
            ? item.transaction.boleto_url
            : item.transactionPagarme.boleto_url;
          if (
            new Date(item.transactionPagarme.boleto_expiration_date) >
            new Date()
          ) {
            message =
              "*Parabéns " +
              nome +
              "!* Você economizou *R$ " +
              economia +
              "* no mês de " +
              competencia +
              " em sua conta de energia. Faça seu pagamento no valor de *R$ " +
              valor +
              "* até " +
              venc +
              " usando o código " +
              barcode +
              " ou baixe seu boleto em " +
              boleto_url +
              ". Acesse agora nossos aplicativos para ver o detalhamento de sua fatura.";
          } else {
            message =
              "*" +
              nome +
              " SUA FATURA ESTÁ EM ATRASO!* Você economizou *R$ " +
              economia +
              "* no mês de " +
              competencia +
              " em sua conta de energia. Não perca a chance de continuar economizando. Faça o pagamento no valor de *R$ " +
              valor +
              "* até " +
              venc +
              " usando o código " +
              barcode +
              " ou baixe seu boleto em " +
              boleto_url +
              ". Acesse agora nossos aplicativos para ver o detalhamento de sua fatura.";
          }
        } else {
          let status = this.formatStatus(item.status || "");
          message =
            "*Parabéns " +
            nome +
            "!* Você economizou *R$ " +
            economia +
            "* no mês de " +
            competencia +
            " em sua conta de luz. Fizemos o processamento de sua fatura no valor de R$ " +
            valor +
            " no cartão de crédito, o status da sua fatura é *" +
            status +
            "*. Acesse agora nossos aplicativos para ver o detalhamento de sua fatura. _Obrigado por ajudar a melhorar nosso planeta_.";
        }
      }
      return encodeURI(url + message);
    },
    gotoTransactionHistory(transaction_id) {
      // console.log(transaction_id)
      eventBus.$emit("billing_id", transaction_id);
      eventBus.$emit("right", true);
      // this.$router.replace(`/transaction/${transaction_id}`)
    },
    formatStatus(status) {
      if (status === "") return "";
      if (status === "pending") return "Aguardando Pagamento";
      if (status === "paid") return "Fatura Paga";
      if (status === "succeeded") return "Fatura Paga";
      if (status === "failed") return "Falha ao realizar cobrança";
      if (status === "processing")
        return "Transação está em processo de autorização.";
      if (status === "authorized")
        return "Transação foi autorizada. Cliente possui saldo na conta e este valor foi reservado para futuro faturamento.";
      if (status === "refunded") return "Transação estornada completamente.";
      if (status === "waiting_payment" || status === "opened")
        return "Aguardando pagamento.";
      if (status === "refused")
        return "Transação recusada, não autorizada. Por favor, entre em contato conosco.";
      if (status === "analyzing")
        return "Transação encaminhada para a análise manual feita por um especialista em prevenção a fraude.";
      if (status === "pending_review")
        return "Transação pendente de revisão manual.";
    },
    _export(items) {
      /* convert state to workbook */
      items.forEach((item, index) => {
        item.id = index;
        /*
                var ucs = [];
                item.consumer_units.forEach(uc => {
                    ucs.push(uc.consumer_unit)
                })
                */
        let taxa = 0;
        let receita = 0;
        let total_consumo_kW = 0;
        let valor_kwh = (item.amount * 1) / (item.amount_kW * 1) || 1;
        if (item.transaction && item.competence < "2019-07") {
          taxa = item.transaction.cost;
          receita = item.total - item.transaction.cost;
          total_consumo_kW = parseInt(
            (item.total_utility_company * 1) / valor_kwh,
          );
        } else {
          if (item.transactionPagarme && item.transactionPagarme.payables) {
            taxa =
              this.sumFee(item.transactionPagarme.payables) +
              (item.transactionPagarme.payment_method === "credit_card"
                ? item.transactionPagarme.cost / 100
                : 0);
            receita =
              item.total -
              (this.sumFee(item.transactionPagarme.payables) +
                (item.transactionPagarme.payment_method === "credit_card"
                  ? item.transactionPagarme.cost / 100
                  : 0));
          } else {
            taxa = 0;
            receita = 0;
          }
          total_consumo_kW = parseInt(
            (item.tarifa * 1 || item.total_utility_company * 1) / valor_kwh,
          );
        }
        this.data.push([
          index + 1,
          item.competence,
          item.user.name || 0,
          // ucs,
          item.amount_kW * 1,
          total_consumo_kW / valor_kwh || 0,
          parseInt(item.custo_disp / valor_kwh) || 0,
          item.amount_kW / this.total,
          item.amount * 1,
          item.total * 1,
          taxa * 1 || 0,
          receita * 1 || 0,
          item.discount * 1,
          item.balance || 0,
          item.transaction ? item.transaction.payment_method : "" || "",
          item.status || "",
          item.customer_id,
        ]);
        // console.log('data: ', this.data)
      });
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();

      const file = "faturamento_" + this.formatFileName(new Date());
      // XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      XLSX.utils.book_append_sheet(wb, ws, file);
      /* generate file and send to client */
      XLSX.writeFile(wb, file + ".xlsx");
    },
    formatFileName(value) {
      if (!value) return "";
      const year = value.getYear();
      const month = value.getMonth() + 1;
      const day = value.getDay();
      const hour = value.getHours();
      const minute = value.getMinutes();
      return day + "" + month + "" + year + "" + hour + "" + minute;
    },
    sumFee(value) {
      if (!value || value.length === 0) return 0;
      var sum = value.reduce(function (sum, elem) {
        return sum + elem.fee;
      }, 0);
      return sum / 100;
    },
    formatCurrencyEmail(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  filters: {
    formatCurrency(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatPercent(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val;
    },
    formatStatus: function (value) {
      if (!value) return "";

      if (value === "paga" || value === "succeeded" || value === "paid") {
        return "done_outline";
      } else if (
        value === "aberta" ||
        value === "pending" ||
        value === "waiting_payment" ||
        value === "opened"
      ) {
        return "schedule";
      } else if (value === "free") {
        return "free_breakfast";
      } else {
        return "error";
      }
    },
    formatPaymentType: function (value) {
      if (!value) return "";

      if (value === "credit" || value === "credit_card") return "credit_card";
      else return "mdi-barcode";
    },
    formatName: function (value) {
      if (!value) return "";
      if (value.length > 25) {
        return value.substr(0, 25) + "...";
      } else {
        return value;
      }
    },
    sumFee(value) {
      if (!value || value.length === 0) return 0;
      var sum = value.reduce(function (sum, elem) {
        return sum + elem.fee;
      }, 0);
      return sum / 100;
    },
  },
};
</script>
